<template>
  <div class="row y-gap-30">
    <!----------Next 4 components------------->
    <div class="col-12">
      <!----- start of  Blog card -->
      <div class="singleBlogCard -type-1">
        <div class="blogCard__image">
          <img class="w-1/1 rounded-8" src="../../assets/images/home/blog-1.png" alt="image" width="788" height="450" />
        </div>
        <div class="blogCard__content mt-20">
          <div class="blogCard__category">Delay Analysis & EOT Claims</div>
          <!--------- User Icon and name---------->
          <div class="d-flex align-items-center icon-container mt-25">
            <div class="icon rounded-full">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path
                  d="M1 15C1 13.9391 1.42143 12.9217 2.17157 12.1716C2.92172 11.4214 3.93913 11 5 11H13C14.0609 11 15.0783 11.4214 15.8284 12.1716C16.5786 12.9217 17 13.9391 17 15C17 15.5304 16.7893 16.0391 16.4142 16.4142C16.0391 16.7893 15.5304 17 15 17H3C2.46957 17 1.96086 16.7893 1.58579 16.4142C1.21071 16.0391 1 15.5304 1 15Z"
                  stroke="#94AD04" stroke-width="1.5" stroke-linejoin="round" />
                <path
                  d="M9 7C10.6569 7 12 5.65685 12 4C12 2.34315 10.6569 1 9 1C7.34315 1 6 2.34315 6 4C6 5.65685 7.34315 7 9 7Z"
                  stroke="#94AD04" stroke-width="1.5" />
              </svg>
            </div>
            <div>
              <h4 class="blogCard__title text-18 lh-15 fw-500">
                By Ali Katary, Expert Engineer.
              </h4>
              <div class="blogCard__date mt-5">Jan 22, 2024</div>
            </div>
          </div>
          <!--/end of user icon-->

          <div class="mb-50 mt-50">
            <p class="singleblog-pragraph">
              Lorem ipsum dolor sit amet consectetur. Sed vitae morbi ut tellus
              aenean nunc tellus. Consectetur vitae nunc non adipiscing tellus
              metus tellus gravida. Diam a nulla enim scelerisque et elementum.
              Leo mattis cras faucibus consectetur quam diam. Arcu eu urna id
              mollis sagittis quis nisi aliquet. Nisi libero pulvinar eu sed
              viverra interdum venenatis. Eu ut massa placerat fermentum ac est
              odio euismod ultricies. Duis volutpat pellentesque eget tempus
              senectus turpis lectus ut. Suspendisse nisl eget ac facilisis
              tempor faucibus lorem. Amet enim leo id fermentum sapien duis
              mattis. Quis nisl aliquam maecenas sit cras leo adipiscing tellus.
              Integer varius erat et sagittis. Vulputate at quis nibh vitae
              phasellus feugiat tortor in. Adipiscing eget volutpat est
            </p>
          </div>
          <!--start of comments section-->
          <div class="blog-comments">
            <h3 class="mb-20">Comments (2)</h3>
            <!-------user Comment start-------->
            <div class="userComment">
              <div class="d-flex align-items-centerv x-gap-10">
                <div class="testimonials__image">
                  <img src="../../assets/images/home/insteractor.png" alt="image" />
                </div>
                <div>
                  <div class="text-24 fw-600 testimonials-name">
                    Courtney Henry
                  </div>
                  <div class="text-16 mt-0 fw-400 testimonials-position">
                    Web Designer
                  </div>
                </div>
              </div>

              <div class="mt-25">
                <p class="text-16 fw-400">
                  Ut pharetra ipsum nec leo blandit, sit amet tincidunt eros
                  pharetra. Nam sed imperdiet testimonial turpis. In hac
                  habitasse platea dictumst. Praesent nulla massa, hendrerit
                  vestibulum gravida in, feugiat auctor felis.
                </p>
              </div>
            </div>
            <!-----------user comment end-->

            <!-------user Comment start-------->
            <div class="userComment">
              <div class="d-flex align-items-centerv x-gap-10">
                <div class="testimonials__image">
                  <img src="../../assets/images/home/insteractor.png" alt="image" />
                </div>
                <div>
                  <div class="text-24 fw-600 testimonials-name">
                    Courtney Henry
                  </div>
                  <div class="text-16 mt-0 fw-400 testimonials-position">
                    Web Designer
                  </div>
                </div>
              </div>

              <div class="mt-25">
                <p class="text-16 fw-400">
                  Ut pharetra ipsum nec leo blandit, sit amet tincidunt eros
                  pharetra. Nam sed imperdiet testimonial turpis. In hac
                  habitasse platea dictumst. Praesent nulla massa, hendrerit
                  vestibulum gravida in, feugiat auctor felis.
                </p>
              </div>
            </div>
            <!-----------user comment end-->
          </div>
          <!--end of comments section-->
          <!----add post form----------------->
          <div class="post-form mt-30 mb-10">
            <h3 class="text-24 fw-600">{{ $t('leave_a_review') }}</h3>
            <form>
              <div class="mt-25">
                <textarea class="form-control" rows="6" placeholder="Leave a review"></textarea>
              </div>
              <button class="main-button mt-25 rotate-svg">
                <span>Post </span>
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M15.586 10.6569L11.636 6.70692C11.4538 6.51832 11.353 6.26571 11.3553 6.00352C11.3576 5.74132 11.4628 5.49051 11.6482 5.3051C11.8336 5.11969 12.0844 5.01452 12.3466 5.01224C12.6088 5.00997 12.8614 5.11076 13.05 5.29292L18.707 10.9499C18.8002 11.0426 18.8741 11.1527 18.9246 11.2741C18.9751 11.3954 19.001 11.5255 19.001 11.6569C19.001 11.7883 18.9751 11.9184 18.9246 12.0398C18.8741 12.1611 18.8002 12.2713 18.707 12.3639L13.05 18.0209C12.9578 18.1164 12.8474 18.1926 12.7254 18.245C12.6034 18.2974 12.4722 18.325 12.3394 18.3262C12.2066 18.3273 12.0749 18.302 11.952 18.2517C11.8291 18.2015 11.7175 18.1272 11.6236 18.0333C11.5297 17.9394 11.4555 17.8278 11.4052 17.7049C11.3549 17.582 11.3296 17.4503 11.3307 17.3175C11.3319 17.1847 11.3595 17.0535 11.4119 16.9315C11.4643 16.8095 11.5405 16.6992 11.636 16.6069L15.586 12.6569H6C5.73478 12.6569 5.48043 12.5516 5.29289 12.364C5.10536 12.1765 5 11.9221 5 11.6569C5 11.3917 5.10536 11.1373 5.29289 10.9498C5.48043 10.7623 5.73478 10.6569 6 10.6569H15.586Z"
                      fill="white" />
                  </svg>
                </span>
              </button>
            </form>
          </div>
          <!------end of add post form------------------------>
        </div>
      </div>
      <!--------- End of Blog card ---------->
    </div>
    <!---------- blog column end----------------->
  </div>
</template>
